import Fetch from "../../utils/Fetch"
import objectToFormData from "@/utils/ObjectToFormData";
import {getCookie} from "@/utils/Cookie";
import getEstimateItemGoal from "@/utils/getEstimateItemGoal";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";

export default {
    namespaced: true,
    state: {
        stepNum: 1,
        popupEstimateOpened: false,
        preScoreInitials:  JSON.parse(sessionStorage.getItem('pre-score-initials')) || null,
        preScoreAccept: '',
        popupViewMode: 'full',
        estimateForm: {
            'max_loan': '2000',
            'max_term': '20',
            'photos': [],
            'accept': '',
            'courier_required': null,
            'name': '',
            'phone': '',
            'email': '',
            'item_id': '',
            'item_desc': '',
            'city': getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
            'com_types': [],
        },
        estimateFormFlags: {
            showWeightInput: false,
        },
        itemParams: {
            'brand': '',
            'model': '',
            'condition': '',
            'has_receipt': '0',
            'description': '',
            'price_avito': '',
        },
        currentItemFields: [],
        preScoreValues: {
            price: '0',
            percent: '0',
            timeout: null,
        },
        estimateFormTouch: {
            'max_loan': false,
            'max_term': false,
            'photos': false,
            'accept': false,
        },
        isEstimateItemGoalSent: false,
        validateExcludedKeys: ['item_desc', 'com_types', 'courier_required', 'city', 'flaws'],
        pignusId: null,
    },
    mutations: {
        setStepNum(state, value) {
            state.stepNum = value
        },
        setPreScoreInitials(state, data) {
            state.preScoreInitials = data
            sessionStorage.setItem('pre-score-initials', JSON.stringify(data))
        },
        setPreScoreAccept(state, value) {
            state.preScoreAccept = value
        },
        sortAccepts(state) {
            if (!state.preScoreAccept || !state.preScoreInitials['accept_types']) return
            if (state.preScoreInitials['accept_types'].length < 2) {
                state.estimateForm['accept'] = String(state.preScoreInitials['accept_types'][0].id)
                return;
            }

            let sortedAccepts = Array.from(state.preScoreInitials['accept_types']).sort((a, b) => {
                if (b.xml_id === state.preScoreAccept) state.estimateForm['accept'] = String(b.id)
                if (a.xml_id === state.preScoreAccept) {
                    state.estimateForm['accept'] = String(a.id)
                    return -1
                } else {
                    return 1
                }
            })
            state.preScoreInitials['accept_types'] = sortedAccepts
        },
        setEstimateFormKey(state, {key, value}) {
            if (!key) return
            state.estimateForm[key] = value
        },
        setEstimateFormFlag(state, {key, value}) {
            if (!key) return
            state.estimateFormFlags[key] = value
        },
        setPopupViewMode(state, value) {
            state.popupViewMode = value
        },
        setPopupOpenedStatus(state, value) {
            state.popupEstimateOpened = value
        },
        setEstimateFormTouch(state, {key, value}) {
            if (!key) return
            state.estimateFormTouch[key] = value
        },
        clearEstimateFormTouch(state) {
            state.estimateFormTouch = {
                'max_loan': false,
                'max_term': false,
                'photos': false,
                'accept': false,
            }
        },
        setItemParamsKey(state, {key, value}) {
            if (!key) return
            const previousValue = state.itemParams[key]
            state.itemParams[key] = value
            if (key === 'manufacturer_id' && value !== previousValue) {
                state.itemParams.model_list = ''
                state.itemParams.new_manufacturer = ''
                state.itemParams.manufacturer_id_other = ''
                state.itemParams.new_model = ''
                state.itemParams.model_other = ''
            } else if (key === 'model_list' && value !== previousValue) {
                state.itemParams.new_model = ''
                state.itemParams.model_other = ''
            }
            if (key === 'sample') {
                if ('color' in state.itemParams) {
                    state.itemParams['color'] = ''
                }
            }
        },
        setDefaultItemParams(state) {
            state.itemParams = {
                'brand': '',
                'model': '',
                'condition': '',
                'has_receipt': '0',
                'description': '',
            }
        },
        setCurrentItemFields(state, data) {
            if (!data) return
            state.currentItemFields = data
            data.find(item => {
                if(!item.is_required) {
                    state.validateExcludedKeys.push(item.xml_id)
                }
            })
        },
        clearCurrentItem(state) {
            state.currentItemFields = []
        },
        setPreScoreValues(state, {price, percent}) {
            state.preScoreValues.price = price
            state.preScoreValues.percent = percent
        },
        clearDefaultItemParams(state) {
            state.itemParams = {}
        },
        setEstimateItemGoalSentStatus(state, value) {
            state.isEstimateItemGoalSent = value;
        },
        setPignusId(state, value) {
            state.pignusId = value;
        }
    },
    actions: {
        async loadPreScoreInitials({commit, state}) {
            if (state.preScoreInitials) return
            let response = await Fetch('forms/pre-score/initials/')
            if (response.success) {
                await commit('setPreScoreInitials', response.data)
            }
            if (state.preScoreAccept) {
                commit('sortAccepts')
                commit('setEstimateFormTouch', {key: 'accept', value: true})
            }
        },

        async loadPreScoreValues({commit, state, getters}) {
            let url = new URL('https://fl-dev.xpager.ru/api/desktop/pre-score/')

            if (!getters.getItemParamsCompleteStatus) return
            Object.entries(state.itemParams).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    if (value.length) {
                        for (let i = 0; i <= value.length - 1; i++) {
                            url.searchParams.append(`${key}[]`, value[i])
                        }
                    }
                } else if (value) {
                    url.searchParams.set(`${key}`, String(value))
                }
            })
            let response = await Fetch(`pre-score/item/${state.estimateForm['item_id']}/calculate/${url.search}`)
            if (response.success) {
                commit('setPreScoreValues', {
                    price: response.data.price,
                    percent: '0.364'
                })
            } else {
                commit('setPreScoreValues', {
                    price: '—',
                    percent: '—'
                })
            }
        },

        async loadItemFields({commit, state, getters}) {
            if (!state.estimateForm.item_id || !state.estimateForm.accept) return
            if (getters.getAcceptItemData(state.estimateForm.accept, state.estimateForm.item_id).is_def_calc) {
                commit('setDefaultItemParams')
                commit('setCurrentItemFields', [])
                return
            }
            let response = await Fetch(`pre-score/item/${state.estimateForm.item_id}/fields/`)
            if (response.success) {
                commit('clearDefaultItemParams')
                commit('setCurrentItemFields', response.data)
            }
        },

        async sendEstimateForm({commit, state, dispatch, rootGetters}, {mode, signal}) {
            let body
            let response
            let token 
            
            signal?.throwIfAborted()
            token = await executeRecaptcha({signal})
            signal?.throwIfAborted()

            if (mode === 'short' || !mode) {
                const data = {
                    'max_loan': state.estimateForm['max_loan'],
                    'max_term': state.estimateForm['max_term'],
                    'photos': state.estimateForm['photos'],
                    'item_desc': state.estimateForm['item_desc'],
                    'client[fio]': state.estimateForm['name'],
                    'client[phone]': state.estimateForm['phone'],
                    'client[city]': state.estimateForm['city'],
                    'client[email]': state.estimateForm['email'],
                    'com_types[]': state.estimateForm['com_types'],
                    'token': token
                };

                const promoId = rootGetters['getPopupPromoData']?.promo_id;
                if(promoId) {
                    data.promo_id = promoId;
                }

                body = objectToFormData(data)
                if (rootGetters['location/isCourierAvailable'](state.estimateForm['city'])) {
                    body.append('courier_required', Number(state.estimateForm['courier_required']))
                }
                response = await Fetch('forms/pre-score/', {
                    method: 'POST',
                    body,
                    signal
                })
            } else {
                const data = {
                    'max_loan': state.estimateForm['max_loan'],
                    'max_term': state.estimateForm['max_term'],
                    'photo': state.estimateForm['photos'],
                    'item_id': state.estimateForm['item_id'],
                    'client[fio]': state.estimateForm['name'],
                    'client[phone]': state.estimateForm['phone'],
                    'client[city]': state.estimateForm['city'],
                    'client[email]': state.estimateForm['email'],
                    'com_types[]': state.estimateForm['com_types'],
                    'token': token
                }

                const promoId = rootGetters['getPopupPromoData']?.promo_id;
                if(promoId) {
                    data.promo_id = promoId;
                }

                body = objectToFormData(data)

                if (rootGetters['location/isCourierAvailable'](state.estimateForm['city'])) {
                    body.append('courier_required', Number(state.estimateForm['courier_required']))
                }

                Object.entries(state.itemParams).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        for (let i = 0; i <= value.length - 1; i++) {
                            body.append(`params[${key}][]`, value[i])
                        }
                    } else if (value) {
                        body.append(`params[${key}]`, value)
                    }
                })

                response = await Fetch('pre-score/detail/save/', {
                    method: 'POST',
                    body,
                    signal
                })
            }

            signal?.throwIfAborted()
            if (response.success) {
                dispatch('sentYmEstimateGoal', {itemId: state.estimateForm['accept'], isSubmit: true});
                commit('clearEstimateFormTouch')
                dispatch('clearEstimateForm')
                commit('clearDefaultItemParams')
                commit('setDefaultItemParams')
                commit('setPopupPromoData', {title: 'Узнать больше', promoId: null, ymGoal: ''}, { root: true })
                return response
            } else {
                return response
            }
        },
        clearEstimateForm({state, rootGetters}) {
            const userData = rootGetters['user/getUserData'];

            state.estimateForm = {
                'max_loan': '2000',
                'max_term': '20',
                'photos': [],
                'accept': '',
                'courier_required': true,
                'name': userData ? userData.name : '',
                'phone':  userData ? userData.phone : '',
                'email':  userData ? userData.email : '',
                'item_id': '',
                'item_desc': '',
                'city': getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
                'com_types': []
            }
        },
        openPopupEstimate({commit, rootGetters, getters, dispatch}, {mode, city}) {
            commit('setPopupViewMode', mode)
            commit('setStepNum', 1)
            commit('setPopupOpenedStatus', true)
            if (city) {
                commit('setEstimateFormKey', {key: 'city', value: rootGetters['location/getCityIdByName'](city)});
            }
            if (getters["getEstimateFormKey"]('accept') && !getters['getEstimateItemGoalSentStatus']) {
                dispatch('sentYmEstimateGoal', {itemId: getters["getEstimateFormKey"]('accept'), isSubmit: false});
            }
            window.fancyboxConstructor.show([{src: "#loan-popup", type: "inline"}], {
                Toolbar: false,
                dragToClose: false,
                Thumbs: false,
                closeButton: "outside",
                mainClass: "fancybox-modal",
                showClass: "fancybox-zoomIn",
                hideClass: "fancybox-zoomOut",
                autoFocus: false,
                trapFocus: false,
                click: (fancybox) => {
                    fancybox.close()
                },
                on: {
                    // Reset at the start of closing, before Fancybox's exit animation.
                    closing: () => {
                        commit('setPopupOpenedStatus', false)
                    }
                }
            })
        },
        sentYmEstimateGoal({commit, getters}, {itemId, isSubmit}) {
            const acceptData = getters["getAcceptData"](itemId);
            if (!acceptData) return;

            let goal = getEstimateItemGoal(acceptData.xml_id, getters["getPopupViewMode"], isSubmit);
            if (!goal) return;

            window.sendYM(goal);

            if (!isSubmit) {
                commit('setEstimateItemGoalSentStatus', true);
            } else {
                commit('setEstimateItemGoalSentStatus', false);
            }
        },
        async requestPhotoDetection(_, photo) {
            let token = '';
            await executeRecaptcha().then(async (tokenRecaptcha) => token = tokenRecaptcha);
            const data = {
                'photo': [photo],
                token,
            }
            const body = objectToFormData(data);
            return Fetch('forms/detection-tech/', {method: 'POST', body});
        },
        async requestDetectedItemInfo(_, name) {
            return Fetch(`pre-score/item/search/?name=${name}`);
        },

        async requestPignusModels(_, {name, brandModelType}) {
            return Fetch(`pignus/get/models/${name}/${brandModelType}/`);
        },

        async requestPignusCreate({state}, {signal} = {}) {
            let token = '';
            signal?.throwIfAborted()
            token = await executeRecaptcha({signal});
            signal?.throwIfAborted()
            const data = {
                'max_loan': state.estimateForm['max_loan'],
                'max_term': state.estimateForm['max_term'],
                'photo': state.estimateForm['photos'],
                'item_id': state.estimateForm['item_id'],
                'client[fio]': state.estimateForm['name'],
                'client[phone]': state.estimateForm['phone'],
                'client[city]': state.estimateForm['city'],
                'client[email]': state.estimateForm['email'],
                'com_types[]': state.estimateForm['com_types'],
                'token': token
            }
            const body = objectToFormData(data);
            Object.entries(state.itemParams).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    for (let i = 0; i <= value.length - 1; i++) {
                        body.append(`params[${key}][]`, value[i])
                    }
                } else if (value) {
                    body.append(`params[${key}]`, value)
                }
            })

            return Fetch('/pignus/send/', {method: 'POST', body, signal});
        },
        
        async requestCheckPignusStatus(_, id) {
   
            return Fetch(`/pignus/status/${id}/`);
        },
        
    },
    getters: {
        getStepNum: state => state.stepNum,
        getPreScoreInitials: state => state.preScoreInitials,
        getEstimateFormKey: state => key => state.estimateForm[key],
        getEstimateFormTouch: state => key => state.estimateFormTouch[key],
        getEstimateFormFlag: state => flag => state.estimateFormFlags[flag],
        getPopupViewMode: state => state.popupViewMode,
        getPopupOpenedStatus: state => state.popupEstimateOpened,
        getAcceptData: state => id => state.preScoreInitials['accept_types']?.find(i => String(i.id) === String(id)) || null,
        getAcceptItems: state => id => state.preScoreInitials['accept_types']?.find(i => String(i.id) === String(id))?.items || [],
        getAcceptItemData: state => (acceptId, itemId) => {
            let accept = state.preScoreInitials['accept_types'].find(i => String(i.id) === String(acceptId))
            if (accept && accept.items.length) {
                return accept.items.find(i => String(i.id) === String(itemId)) || null
            }
        },
        getItemParamsKey: state => key => {
            if (key in state.itemParams) {
                return state.itemParams[key]
            } else {
                state.itemParams[key] = ''
                return state.itemParams[key]
            }
        },
        getPreScoreValues: state => state.preScoreValues,
        getCurrentItemFields: state => state.currentItemFields,
        getItemFieldVisible: state => item => {
            const manufacturer = state.itemParams.manufacturer_id
            if (['manufacturer_id_other', 'new_manufacturer'].includes(item.xml_id)) {
                return manufacturer === 'Другое'
            }
            if (item.xml_id === 'model_list') {
                return Boolean(manufacturer) && manufacturer !== 'Другое'
            }
            if (['model_other', 'new_model'].includes(item.xml_id)) {
                return Boolean(manufacturer) && manufacturer !== 'Другое' && state.itemParams.model_list === 'Другое'
            }
            return true
        },
        getItemFieldRequired: (state, getters) => item => {
            if (!getters.getItemFieldVisible(item)) return false
            return Boolean(item.is_required
                || ['manufacturer_id_other', 'new_manufacturer'].includes(item.xml_id)
                || (item.required_without && !state.itemParams[item.required_without]))
        },
        getItemParamsCompleteStatus: (state, getters) => {
            return state.currentItemFields.every(item => {
                if (!getters.getItemFieldRequired(item)) return true
                const value = state.itemParams[item.xml_id]
                if (Array.isArray(value)) return value.length > 0
                if (typeof value === 'string') return value.trim().length > 0
                return Boolean(value)
            })
        },
        formCompleteStatus: (state, getters) => () => {
            let status = true


            Object.entries(state.estimateForm).forEach(([key, value]) => {
                //Теперь исключения хранятся в store
                if (!state.validateExcludedKeys.includes(key)) {

                    if (Array.isArray(value)) {
                        if (!value.length) status = false
                    } else {
                        if (typeof value !== 'boolean') {
                            if (!value) status = false
                        }
                    }
                }
            })

            let paramsStatus = getters.getItemParamsCompleteStatus
            if (!paramsStatus) status = false

            return status
        
        },
        getEstimateItemGoalSentStatus: state => state.isEstimateItemGoalSent,
        getPignusId: state => state.pignusId,
    }
}
